import type { IndicatorName } from "./types";
import type { IndicatorSettings } from "./indicatorSettings";

export const INDICATOR_DEFAULTS_EXTENDED: Partial<Record<IndicatorName, IndicatorSettings>> = {
  zigZag: {
    deviation: 5,
    depth: 12,
    backstep: 3,
    mainLine: { visible: true, color: "#eab308", width: 2 },
  },
  superTrend: {
    atrPeriod: 10,
    multiplier: 3,
    up: { visible: true, color: "#ef4444", width: 2 },
    down: { visible: true, color: "#22c55e", width: 2 },
  },
  parabolicSAR: {
    acceleration: 0.02,
    maxAcceleration: 0.2,
    mainLine: { visible: true, color: "#22c55e", width: 1 },
  },
  osMA: {
    fastEmaPeriod: 12,
    slowEmaPeriod: 26,
    signalSmaPeriod: 9,
    histogramVisible: true,
    histogramColor: "#22c55e",
  },
  mACD: {
    fastPeriod: 12,
    slowPeriod: 26,
    signalPeriod: 9,
    histogramVisible: true,
    upColor: "#22c55e",
    downColor: "#ef4444",
    macd: { visible: true, color: "#22c55e", width: 1 },
    signal: { visible: true, color: "#ef4444", width: 1 },
  },
  ichimokuKinkoHyo: {
    tenkanSenPeriod: 9,
    kijunSenPeriod: 26,
    senkouSpanBPeriod: 52,
    tenkanSen: { visible: true, color: "#eab308", width: 1 },
    kijunSen: { visible: true, color: "#ef4444", width: 1 },
    chikouSpan: { visible: true, color: "#14b8a6", width: 1 },
    senkouSpanA: { visible: true, color: "#22c55e", width: 1 },
    senkouSpanB: { visible: true, color: "#f97316", width: 1 },
  },
  stochasticOscillator: {
    kPeriod: 14,
    dPeriod: 3,
    smoothingPeriod: 3,
    movingAverage: "SMA" as const,
    kLine: { visible: true, color: "#3b82f6", width: 1 },
    dLine: { visible: true, color: "#f97316", width: 1 },
    upperLevel: { visible: true, color: "#14b8a6", width: 1, value: 80 },
    lowerLevel: { visible: true, color: "#eab308", width: 1, value: 20 },
  },
  rSI: {
    period: 14,
    mainLine: { visible: true, color: "#22c55e", width: 1 },
    level1: { visible: true, color: "#14b8a6", width: 1, value: 70 },
    level2: { visible: true, color: "#6b7280", width: 1, value: 50 },
    level3: { visible: true, color: "#eab308", width: 1, value: 30 },
  },
};
